import styled from 'styled-components';

import BlogCard from '@klaviyo-mkt/gatsby-components/molecules/blog-card';
import Grid from '@klaviyo-mkt/gatsby-components/utils/grid';

export const ArchiveGrid = styled(Grid)`
  row-gap: 2.4rem;
`;

export const ArchiveWrapper = styled.div`
  grid-column: 1 / -1;
`;

export const ArchiveBlogCard = styled(BlogCard)`
  grid-column: 1 / -1;

  ${({ theme }) => theme.screenSize.s576.mediaQuery} {
    grid-column: span 4;
  }
`;
